import { useEffect, useState } from 'react';

import { SearchFilterOption, SearchWithFilterInputProps } from './search-with-filter-input.types';

interface ViewProps {
    valid: boolean;
    touched: boolean;
    changeTouched: React.Dispatch<React.SetStateAction<boolean>>;
    isValid: () => boolean;
    filterValue: string | null;
    setFilterValue: React.Dispatch<React.SetStateAction<string | null>>;
    selectedFilter: SearchFilterOption | null;
    setSelectedFilter: React.Dispatch<React.SetStateAction<SearchFilterOption | null>>;
}

const useSearchWithFilterInput = (props: SearchWithFilterInputProps): ViewProps => {
    const [touched, changeTouched] = useState<boolean>(false);
    const [valid, changeValid] = useState<boolean>(false);
    const [filterValue, setFilterValue] = useState<string | null>(null);
    const [selectedFilter, setSelectedFilter] = useState<SearchFilterOption | null>(props.filterOptions?.[0] ?? null);

    useEffect(() => {
        if (props.resetInput) {
            setFilterValue('');
        }
    }, [props.resetInput]);

    useEffect(() => {
        if (filterValue === null) return;
        const timeOutId = setTimeout(() => onChange(filterValue), 300);
        return () => clearTimeout(timeOutId);
    }, [filterValue]);

    useEffect(() => {
        if (props.selectedFilterKey && props.filterOptions) {
            const found = props.filterOptions.find((opt) => opt.key === props.selectedFilterKey);
            if (found) setSelectedFilter(found);
        }
    }, [props.selectedFilterKey, props.filterOptions]);

    const onChange = async (value: string) => {
        props.onChange && props.onChange(value, selectedFilter?.key ?? null);
    };

    const isValid = (): boolean => {
        let check = true;
        if (check === true && props.required === true && (props.value === '' || props.value === undefined)) check = false;
        if (props.valid !== undefined && check === true) check = props.valid;
        changeValid(check);
        return check;
    };

    useEffect(() => {
        if (props.isValidCallback) {
            props.isValidCallback(isValid());
        } else isValid();
    }, [props.value, props.valid]);

    useEffect(() => {
        if (props.submitted) {
            !touched && changeTouched(true);
            isValid();
        }
    }, [props.submitted]);

    return {
        valid,
        touched,
        changeTouched,
        isValid,
        filterValue,
        setFilterValue,
        selectedFilter,
        setSelectedFilter
    };
};

export default useSearchWithFilterInput;
